import { type QuizConfig } from "~/types/quiz";
import {
  assertUniqueQuizIds,
  generatedQuizzesSchema,
  toQuizConfig,
} from "~/lib/quiz/generated-schema";
import generatedQuizData from "./quizzes/generated.json";
import { proveraNivoaStresa } from "./quizzes/provera-nivoa-stresa";
import { daLiMiJePotrebanPsiholog } from "./quizzes/da-li-mi-je-potreban-psiholog";
import { otpornostNaStres } from "./quizzes/otpornost-na-stres";
import { testSamopouzdanja } from "./quizzes/test-samopouzdanja";
import { procenaAnksioznosti } from "./quizzes/procena-anksioznosti";
import { testTraumeIzDetinjstva } from "./quizzes/traume-iz-detinjstva";
import { procenaNarcisoidnosti } from "./quizzes/procena-narcisoidnosti";
import { procenaPartnerskeNarcisoidnosti } from "./quizzes/procena-partnerske-narcisoidnosti";
import { procenaKomunikacijeUVezama } from "./quizzes/procena-komunikacije-u-vezama";
import { procenaDepresije } from "./quizzes/procena-depresije";
import { procenaToksicneVeze } from "./quizzes/procena-toksicne-veze";
import { big5Personality } from "./quizzes/big-5-personality";
import { emocijalnaInteligencija } from "./quizzes/emocijalna-inteligencija";
import { fiveLoveLanguages } from "./quizzes/five-love-languages";
import { attachmentStyle } from "./quizzes/attachment-style";
import { prokrastinacijaTest } from "./quizzes/prokrastinacija-test";
import { testBurnout } from "./quizzes/test-burnout";
import { testSocijalneAnksioznosti } from "./quizzes/test-socijalne-anksioznosti";
import { testUsamljenosti } from "./quizzes/test-usamljenosti";
import { testAsertivnosti } from "./quizzes/test-asertivnosti";
import { testOcd } from "./quizzes/test-ocd";
import { testAdhd } from "./quizzes/test-adhd";
import { testInteligencije } from "./quizzes/test-inteligencije";
import { testLicnosti } from "./quizzes/test-licnosti";
import { testNesanice } from "./quizzes/test-nesanice";
import { testEmocionalneZavisnosti } from "./quizzes/test-emocionalne-zavisnosti";
import { testPerfekcionizma } from "./quizzes/test-perfekcionizma";

export const generatedQuizDefinitions =
  generatedQuizzesSchema.parse(generatedQuizData);

export const QUIZ_INDEX_LAST_MODIFIED = generatedQuizDefinitions.reduce(
  (latest, quiz) => (quiz.lastModified > latest ? quiz.lastModified : latest),
  "2026-07-27",
);

export const quizzes: QuizConfig[] = [
  proveraNivoaStresa,
  daLiMiJePotrebanPsiholog,
  emocijalnaInteligencija,
  otpornostNaStres,
  testSamopouzdanja,
  procenaAnksioznosti,
  testTraumeIzDetinjstva,
  procenaNarcisoidnosti,
  procenaPartnerskeNarcisoidnosti,
  procenaKomunikacijeUVezama,
  procenaDepresije,
  procenaToksicneVeze,
  big5Personality,
  fiveLoveLanguages,
  attachmentStyle,
  prokrastinacijaTest,
  testBurnout,
  testSocijalneAnksioznosti,
  testUsamljenosti,
  testAsertivnosti,
  testOcd,
  testAdhd,
  testInteligencije,
  testLicnosti,
  testNesanice,
  testEmocionalneZavisnosti,
  testPerfekcionizma,
  ...generatedQuizDefinitions.map(toQuizConfig),
];

assertUniqueQuizIds(quizzes);

export const getQuizById = (id: string) =>
  quizzes.find((quiz) => quiz.id === id);
